// Hide/reveal ("listen first" / audio_only mode) selection rules.
//
// Extracted so they can be asserted without a DOM: the bug these encode was a selector
// mismatch, and the class names below are the contract between the message renderers
// (Rails `_chat_message` partial, `worker_chat_connection.formatAssistantMessage`, and the
// Japanese/Chinese reading aid renderer in `chat_service.renderProcessedGroups`) and the
// reveal handler.

// Every hideable word span carries `word`. Do NOT narrow this to `js-translatable-text`:
// the reading aid renderer drops that class from punctuation segments and rewrites it to
// `js-translatable-text-no-translation` on non-target-language words, so keying off it left
// those segments permanently stuck behind the grey block.
export const HIDEABLE_WORD_SELECTOR = '.word';

// Marking a layout container `challenge` paints one solid grey slab over the whole bubble
// instead of the per-word blocks the message renders with, so wrapper handling skips them.
export const LAYOUT_CONTAINER_SELECTOR =
  '.chat-message-detail, .pronunciation-message, .pronunciation-message-item, .translated-message';

// A message is revealed as a whole and re-hidden as a whole. Deriving one target state for
// every span (rather than flipping each independently) keeps a partially revealed message
// from inverting into "target language hidden, everything else shown".
export function shouldHideAll(challengeFlags) {
  return !challengeFlags.some(Boolean);
}
